module.exports = {
          srcSet: __webpack_public_path__ + "512b299a.jpg"+" 700w"+","+__webpack_public_path__ + "c51b30b7.jpg"+" 1400w"+","+__webpack_public_path__ + "9c538247.jpg"+" 1440w",
          images:[ {path: __webpack_public_path__ + "512b299a.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "c51b30b7.jpg",width: 1400,height: 1050},{path: __webpack_public_path__ + "9c538247.jpg",width: 1440,height: 1080}],
          src: __webpack_public_path__ + "512b299a.jpg",
          toString:function(){return __webpack_public_path__ + "512b299a.jpg"},
          
          width: 700,
          height: 525
        }